import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";
import { useMediaQuery } from "@uidotdev/usehooks";
import Form from "./Form";
import Footer from "./Footer";
import imageSuseUvod from "../catalog/suse-slika-uvod-2025.png";
import imageSuseMetodologija1 from "../catalog/suse-slika_metodologija.png";

import imageSuseTrendovi from "../catalog/suse-slika_trendovi.png";
import imageSuseUticaj from "../catalog/suse-slika-uticaj.png";

import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import ReactHtmlParser from "html-react-parser";

export default function Suse() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const isTabletOrLarger = useMediaQuery("only screen and (min-width: 769px)");
  const [activeTab, setActiveTab] = useState("uvod");
  const [activePodaciTab, setActivePodaciTab] = useState("suse-u-proslosti");

  const [spei, setSpei] = useState("SPEI-3");
  const [month, setMonth] = useState("Jan");
  const [year, setYear] = useState("1950");

  const [imageSrc, setImageSrc] = useState(""); // Držimo putanju slike

  // Učitaj slike iz foldera provera da li radi
  const images = require.context(
    "../slikeProslost2025",
    false,
    /\.(png|jpe?g|svg)$/,
  );

  const getSelectedImage = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };

    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];

    const imageName = `./obs_spei${speiNumber}_${year}_na_na_na_${monthNumber}_eobs.png`;

    try {
      return images(imageName); // <-- obavezno ./ ispred imena
    } catch (error) {
      console.error("Slika nije pronađena:", imageName);
      return "/obs_spei3_1950_na_na_na_1_eobs.png";
    }
  };

  const imagesBuducnost = require.context(
    "../slikeBuducnost2025",
    false,
    /\.(png|jpe?g|svg)$/,
  );

  const getSelectedImageForProjekcije = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];

    // Period parsing
    const periodMap = {
      "2041-2060": "2061-2080",
      "2061-2080": "2061-2080",
      "2081-2100": "2081-2100",
    };

    const periodStr = year.split("-")[1] ? year : periodMap[year];

    const imageName = `spei${speiNumber}_${monthNumber}_${periodStr}_allpct.png`;

    try {
      return imagesBuducnost(`./${imageName}`);
    } catch (error) {
      return imagesBuducnost(`./spei3_1_2061-2080_allpct.png`);
    }
  };

  // useEffect za ažuriranje slike
  useEffect(() => {
    if (activePodaciTab === "suse-u-proslosti") {
      setImageSrc(getSelectedImage());
    } else if (activePodaciTab === "projekcije-za-buducnost") {
      setImageSrc(getSelectedImageForProjekcije());
    }
  }, [spei, month, year, activePodaciTab]);

  const getDownloadDataLink = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];
    const dataFileName = `spei${speiNumber}_${monthNumber}_${year}.nc`;
    const dataFilePath = `/fajloviProslost2025/${dataFileName}`;
    return dataFilePath;
  };

  const getDownloadDataLinkForProjekcije = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];
    return `/fajloviBuducnost2025/spei${speiNumber}_${monthNumber}_${year}_allpct.nc`;
  };

  const data = [
    {
      label: "UVOD",
      value: "uvod",
      desc:
        `<h2>UVOD</h2>
      <p style="margin-bottom: 10px; color: #000;">
        Pojava suše je kompleksni, višeslojni i najčešće dugotrajani proces u kojem se početne anomalije u meteorološkim uslovima nad nekim područjem postepeno šire kroz ostale elemente geofizičkog sistema, a ponekada imaju i uticaja na društveno-ekonomske prilike. Postoje različiti tipovi suše, meteorološka, poljoprivredna, hidrološka i socioekonomska, a svaka od njih odražava posebnu fazu u razvoju ovog fenomena. U početku, suša se javlja kao meteorološka anomalija, poput smanjenih padavina, često praćenih povišenim temperaturama. Kako vreme prolazi, ovi početni poremećaji postepeno se prenose na druge komponente sistema. Kroz interakcije sa zemljištem, vegetacijom i elementima hidrološkog ciklusa, ovi početni impulsi postaju sve složeniji sa dugotrajnijim posledicama. Smanjenje padavina i povišene temperature utiče na smanjenje vlažnosti zemljišta, što dovodi do pojave poljoprivredne suše. Dugotrajni nedostatak vlage u zemljištu dalje može pokrenuti različite poremećaje u u njemu, vegetaciji i kao i poremećaje u hidrološkom ciklusu, stvarajući uslove za hidrološku sušu. Konačno, akumulirani efekti prelaze u socioekonomske posledice koje pogađaju ljude, infrastrukturu i ekonomiju. Upravo taj sled događaja pokazuje da se suša ne može posmatrati samo kao meteorološka pojava, već kao proces u kojem početne meteorološke anomalije pokreću domino-efekat koji oblikuje različite tipove i intenzitete suše.
      </p>` +
        `<p style="margin-bottom: 10px; color: #000;">
        Slika je adaptirana verzija slike iz Cook et al., 2018.
       </p>` +
        `<p style="color: #000;">
          Cook, B.I., Mankin, J.S. & Anchukaitis, K.J. Climate Change and Drought: From Past to Future. Curr Clim Change Rep 4, 164–179 (2018). <a href="https://doi.org/10.1007/s40641-018-0093-2" target="_blank" style="color: #60A5FA;"> https://doi.org/10.1007/s40641-018-0093-2 </a>
        
      </p>` +
        `<p></p>`,
      image: `<img src="${imageSuseUvod}" alt="Suse Uvod" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "METODOLOGIJA",
      value: "metodologija",
      desc:
        `<h2>METODOLOGIJA</h2>
      <p style="margin-bottom: 10px; color: #000;">
      U praksi se susrećemo sa velikom brojem  indeksa i indikatora koji se mogu koristi za praćenje suše.
       Na primer lista različitih indeksa koji su grupisani prema tipu i jednostavnosti primene, na meteorološke, indekse vlažnosti zemljišta, hidrologške itd. može se pronaći na ovom linku <a href="https://www.droughtmanagement.info/indices/" target="_blank" style="color: #60A5FA;">https://www.droughtmanagement.info/indices/</a>.<br /> Sa druge strane u operativnom radu obično se koristi manji broj indeksa, pa tako neki od indeksa koje koristi European Drought Observatory su Standardizovani padavinski indeks (Standardized Precipitation Index - SPI) koji predstavlja meru intenziteta i trajanja deficita ili viška padavina.
        Zatim, indeks anomalije vlažnosti zemljišta (Soil Moisture Index Anomaly Index) koji meri odstupanje sadržaja vode u zoni korena u odnosu na normalne uslove i direktno pokazuje stres biljaka zbog otežanog pristupa vodi. Indeks malih voda (Low-Flow Index) koji se zasniva na simulacijama dnevnog proticaja rečnih tokova i identifikuje produžene periode neuobičajeno niskog protoka, a upoređivanjem sa istorijskim vrednostima ovaj indeks pruža informacije o hidrologškoj suši. Za praćenje stanja vegetacijue se koristi satelitski indikator fAPAR (Fraction of Absorbed Photosynthetically Active Radiation) a njegove negativne anomalije upućuju na loše stanje vegetacije i smanjenu produktivnost. 
        Takođe koristi se i Standardizovani padavinsko-evapotranspiracioni indeks (Standardized Precipitation Evapotranspiration Index - SPEI) koji pored padavina uključuje i potencijalnu evapotranspiraciju, čime ukazuje na odstupanja vodnog bilansa. Posebno je koristan za praćenje meteorološke i poljoprivredne suše u uslovima visokih temperatura i manjka padavina, a slučaju dužih vremenski perioda može ukazivati i na pojavu hidrološke suše. U zavisnosti od vrednosti indeksa obično se definisu tri kategorije suše: Ekstreman suša: SPEI ≤ −2.00; Jaka suša: −2.0 < SPEI ≤ −1.5; Umerena suša: −1.5 < SPEI ≤ −1.0.
</p>` +
        `<p style="color: #000;">
Na slici levo, prikazana je vremenska serija srednje vrednosti za Srbiju, SPEI-6 indeksa za mesec avgust od 1951. do 2024. godine, po odgovarajućim kategorijama.

      </p>`,
      image: `<img src="${imageSuseMetodologija1}" alt="Suse Uvod" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "TRENDOVI",
      value: "trendovi",
      desc:
        `<h2>TRENDOVI</h2>
      <p style="margin-bottom: 10px; color: #000;">
      Tokom realizacije projekta EXTREMES analizana je prostorno-vremenskih promena suše u Srbiji korišćenjem standardizovanog padavinsko-evapotranspiracionog indeksa (SPEI). Analiza je obuhvatila vremenske serije SPEI-1, SPEI-3, SPEI-6 i SPEI-12, izračunate na osnovu E-OBS podataka prostorne rezolucije 0.1° za period 1950–2022 (Djurdjevic i sar., 2024). Utvrđeno je da negativni trendovi preovlađuju u svim mesecima i za sve analizirane vremenske skale indeksa, što ukazuje na učestaliju pojavu suša tokom poslednjih decenija. Poseban fokus stavljen jena SPEI-6 za avgust, jer upravo za ovaj mesec indeksi pokazuju najizraženije negativne trendove, konzistentne kroz različite vremenske skale ovog indeksa. Statistički značajni negativni trendovi SPEI-3, SPEI-6 i SPEI-12 za avgust registrovani su na 11%, 17% i 38% teritorije Srbije. Kako bi se bolje razumele promene u ekstremnim i jakim sušama, primenjena je Inovativna trend analiza (ITA), koja je pokazala da se učestalost ekstremnih i jakih sušnih kategorija u poslednjih 30 godina udvostručila u odnosu na prethodni tridesetogodišnji period. Markovljev lanac ukazao je i na češće prelaze iz neutralnih i vlažnih u sušne kategorije. Fokus na avgust dodatno je motivisan utvrđenom značajnom korelacijom između SPEI-3, SPEI-6 i SPEI-12 za avgust i godišnje proizvodnje kukuruza u Srbiji, što potvrđuje potencijal ovog indeksa za procenu uticaja suše na poljoprivredu. Analizirana je i veza između SPEI vrednosti i različitih indeksa telekonekcija, kao i dugoročnih trendova zagrevanja, pri čemu su rezultati pokazali da se promenjeni obrasci suše mogu dovesti u vezu s kombinovanim efektima globalnog zagrevanja i cirkulacionih anomalija.
</p>` +
        `<p style="margin-bottom: 10px; color: #000;">
Na slici su prikazane vremenske serije SPEI-3, SPEI-6, SPEI-12 indeksa za mesec avgust, za Beograd od 1888. do 2024. godine, i srednje vrednosti za Srbiju od 1950 do 2024.
</p>` +
        `<p style="color: #000;">
Djurdjevic V., Stosic B., Tošić M., Lazić I., Putniković S., Stosic T., Tošić I., 2024, Analysis of recent trends and spatiotemporal changes of droughts over Serbia using high-resolution gridded data, Atmospheric Research, doi: 10.1016/j.atmosres.2024.107376

      </p>`,
      image: `<img src="${imageSuseTrendovi}" alt="Suse Uvod" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "UTICAJ",
      value: "uticaj",
      desc:
        `<h2>UTICAJ</h2>
<p style="margin-bottom: 10px; color: #000;">
U periodu od 2000. do danas, Srbija je pretrpela značajne štete i gubitke izazvane ekstremnim vremenskim i klimatskim događajima, pri čemu su događaji sa najvećim materijalnim gubicima uglavnom bili povezani sa sušama i poplavama. Suše su se pokazale kao najčešći i „najskuplji“ događaji, naročito u 2000, 2003, 2007, 2012, 2017, 2022, 2024 i 2025. godini. Epizode letnjih suša u ovim godinama ostavile su posledice kroz veoma nisku poljoprivrednu proizvodnju, probleme sa vodo-snabdevanjem, šumskim požarima i smanjenom proizvodnjom električne energije a ukupni gubici su se merili sa više stotina miliona evra, pa su čak u pojedinim godinama prelazili i vrednost od jedne milijarde. Ukupno gledano, podaci jasno pokazuju da su suše, posebno u poslednjoj deceniji, najdominantniji i ekonomski najštetniji ekstremni događaji u Srbiji.
</p>` +
        `<p style="margin-bottom: 10px; color: #000;">
Na slici levo prikazana je povezanost suše, kroz srednju vrednosti za Srbiju SPEI indeksa, sa zabeleženim negativnim anomalijama u proizvodnji kukuruza, ukupnoj poljoprivrednoj proizvodnji (Krop indeks Svetske banke i bruto dodate vrednost za delatnost poljoprivreda) i proizvodnja električne energije iz hidroelektrana, tokom perioda od 2001. do 2022. godine. U slučaju proizvodnje kukuruza, Djurdjevic i sar. (2024) su pokazali visok stepen korelacije 0.74 do 0.78 između odgovarajućeg SPEI indeksa i proizvodnje kukuruza u Srbiji.
</p>` +
        `<p style="color: #000;">
Djurdjevic V., Stosic B., Tošić M., Lazić I., Putniković S., Stosic T., Tošić I., 2024, Analysis of recent trends and spatiotemporal changes of droughts over Serbia using high-resolution gridded data, Atmospheric Research, doi: 10.1016/j.atmosres.2024.107376
</p>`,
      image: `<img src="${imageSuseUticaj}" alt="Suse Uvod" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "PODACI",
      value: "podaci",
      tabs: [
        {
          label: "Suše u prošlosti",
          value: "suse-u-proslosti",
          content: (
            <div
              className={`suseDeo ${
                isTabletOrLarger ? "flex" : "flex flex-col"
              }`}
            >
              <div className="suseDeoVeci w-full md:w-2/3 p-4">
                <h3 className="text-lg font-semibold mb-4">Suše u prošlosti</h3>
                <p className="mb-4">
                  Izaberite indeks, mesec i godinu da biste videli sliku:
                </p>

                <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  {/* Filter za SPEI indeks */}
                  <select
                    value={spei}
                    onChange={(e) => setSpei(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="SPEI-3">SPEI-3</option>
                    <option value="SPEI-6">SPEI-6</option>
                    <option value="SPEI-12">SPEI-12</option>
                  </select>

                  {/* Filter za mesec */}
                  <select
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="Jan">Januar</option>
                    <option value="Feb">Februar</option>
                    <option value="Mar">Mart</option>
                    <option value="Apr">April</option>
                    <option value="May">Maj</option>
                    <option value="June">Jun</option>
                    <option value="July">Jul</option>
                    <option value="Aug">Avgust</option>
                    <option value="Sep">Septembar</option>
                    <option value="Oct">Oktobar</option>
                    <option value="Nov">Novembar</option>
                    <option value="Dec">Decembar</option>
                  </select>

                  {/* Filter za godinu */}
                  <select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    {Array.from({ length: 2023 - 1950 + 1 }, (_, index) => (
                      <option key={index} value={1950 + index}>
                        {1950 + index}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Deo za prikaz slike */}
                <div className="mt-6 w-full md:w-auto">
                  <h4 className="text-lg font-semibold">
                    Prikazana slika za {spei}, {month}, {year}
                  </h4>
                  <img
                    src={getSelectedImage()}
                    alt={`Slika za ${spei}, ${month}, ${year}`}
                    className="w-full md:w-auto max-w-md mx-auto"
                  />
                </div>

                {/* Dugmad za preuzimanje */}
                <div className="mt-6 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <a
                    href={getSelectedImage()}
                    download={`Slika-${spei}-${month}-${year}.png`}
                    className="bg-blue-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Preuzmi sliku
                  </a>
                  <a
                    href={getDownloadDataLink()}
                    download={`Podaci-${spei}-${month}-${year}.nc`}
                    className="bg-green-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Preuzmi podatke
                  </a>
                  <a
                    href="/spei_netcdf_data.tgz" // Relativni put do fajla u public folderu
                    download="Suse.tgz" // Ime fajla pod kojim će se preuzeti
                    className="bg-red-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Preuzmi sve podatke
                  </a>
                </div>
              </div>

              {/* Deo za dodatni tekst */}
              <div className="suseDeoManji w-full md:w-1/3 p-4 bg-white border-l">
                <h4 className="text-lg font-semibold">SUŠE U PROŠLOSTI</h4>
                <p className="mt-4 text-black">
                  Ovde možete preuzeti indekse suše SPEI-3, SPEI-6 i SPEI-12,
                  izračunate za svaki mesec i godinu od 1950. do 2023. Indeksi
                  su izračunati korišćenjem E-OBS podataka. Rezultate možete
                  preuzeti u grafičkom formatu ili u numeričkom NetCDF formatu.
                </p>
                <p className="mt-4 text-black">
                  E-OBS podaci: <br />
                  Cornes, R.C., van der Schrier, G., van den Besselaar, E.J.M.,
                  & Jones, P.D. (2018). An Ensemble Version of the E-OBS
                  Temperature and Precipitation Datasets. Journal of Geophysical
                  Research: Atmospheres, 123, 9391–9409.
                </p>
              </div>
            </div>
          ),
        },
        {
          label: "Projekcije za budućnost",
          value: "projekcije-za-buducnost",
          content: (
            <div
              className={`suseDeo ${
                isTabletOrLarger ? "flex" : "flex flex-col"
              }`}
            >
              <div className="suseDeoVeci w-full md:w-2/3 p-4">
                <h3 className="text-lg font-semibold mb-4">
                  Projekcije za budućnost
                </h3>
                <p className="mb-4">
                  Izaberite indeks, mesec i godinu da biste videli projekciju:
                </p>

                <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <select
                    value={spei}
                    onChange={(e) => setSpei(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="SPEI-3">SPEI-3</option>
                    <option value="SPEI-6">SPEI-6</option>
                    <option value="SPEI-12">SPEI-12</option>
                  </select>

                  {/* Filter za mesec */}
                  <select
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="Jan">Januar</option>
                    <option value="Feb">Februar</option>
                    <option value="Mar">Mart</option>
                    <option value="Apr">April</option>
                    <option value="May">Maj</option>
                    <option value="June">Jun</option>
                    <option value="July">Jul</option>
                    <option value="Aug">Avgust</option>
                    <option value="Sep">Septembar</option>
                    <option value="Oct">Oktobar</option>
                    <option value="Nov">Novembar</option>
                    <option value="Dec">Decembar</option>
                  </select>

                  <select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="2041-2060">2041-2060</option>
                    <option value="2061-2080">2061-2080</option>
                    <option value="2081-2100">2081-2100</option>
                  </select>
                </div>

                {/* Deo za prikaz slike */}
                <div className="mt-6 w-full md:w-auto">
                  <h4 className="text-lg font-semibold">
                    Prikazana projekcija za {spei}, {month}, {year}
                  </h4>
                  <img
                    src={getSelectedImageForProjekcije()}
                    alt={`Projekcija za ${spei}, ${month}, ${year}`}
                    className="w-full md:w-auto max-w-md mx-auto"
                  />
                </div>

                {/* Dugmad za preuzimanje */}
                <div className="mt-6 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <a
                    href={getSelectedImageForProjekcije()}
                    download={`Projekcija-${spei}-${month}-${year}.png`}
                    className="bg-blue-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Preuzmi projekciju
                  </a>
                  <a
                    href={getDownloadDataLinkForProjekcije()}
                    download={`Podaci-Projekcija-${spei}-${month}-${year}_allpct.nc`}
                    className="bg-green-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Preuzmi podatke
                  </a>
                  <a
                    href="/svi_podaci_projekcije_buducnost_suse.tgz" // Relativni put do fajla u public folderu
                    download="SuseProjekcije.tgz" // Ime fajla pod kojim će se preuzeti
                    className="bg-red-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Preuzmi sve podatke
                  </a>
                </div>
              </div>

              {/* Deo za dodatni tekst */}
              <div className="suseDeoManji w-full md:w-1/3 p-4 border-l">
                <h4 className="text-lg font-semibold">
                  PROJEKCIJE ZA BUDUĆNOST
                </h4>
                <p className="mt-4 text-black">
                  Ovde možete preuzeti projekcije indeksa suše SPEI-3, SPEI-6 i
                  SPEI-12, izračunate za svaki mesec i četiri različita
                  vremenska isečka u budućnosti (2021-2040, 2041-2060,
                  2061-2080, 2081-2100). Indeksi su izračunati korišćenjem
                  rezultata osam različitih klimatskih modela koji su preuzuti
                  sa Digitalnog atlasa klime Srbije
                  https://atlas-klime.eko.gov.rs. Odabrane projekcije se odnose
                  na dva emisiona scenarija RCP8.5 i RCP4.5. Rezultate možete
                  preuzeti u grafičkom formatu ili u numeričkom NetCDF formatu.
                </p>
                <p className="mt-4 mb-2 text-black">
                  Spisak korišćenih regionalnih klimatskih model:
                </p>
                <ul className="text-black text-md pl-1">
                  <li className="pb-1">- CLMcom-CCLM4-8-17</li>
                  <li className="pb-1">- DMI-HIRHAM5</li>
                  <li className="pb-1">- KNMI-RACMO22E</li>
                  <li className="pb-1">- CLMcom-CCLM4-8-17</li>
                  <li className="pb-1">- KNMI-RACMO22E</li>
                  <li className="pb-1">- CLMcom-CCLM4-8-17</li>
                  <li className="pb-1">- MPI-CSC-REMO2009</li>
                  <li>- MPI-CSC-REMO2009</li>
                </ul>
              </div>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <>
      {isTabletOrLarger && <NavBar />}
      {isSmallDevice && <NavBarMobile />}
      <div className="container mx-auto text-center min-h-screen md:mb-6">
        <Tabs value={activeTab} className="max-w-screen-xl mx-auto">
          <TabsHeader
            className="bg-transparent flex justify-center flex-wrap md:flex-nowrap mx-2 md:mx-0"
            indicatorProps={{
              className: "bg-gray-900/10 shadow-none !text-gray-900",
            }}
            onChange={(value) => setActiveTab(value)}
          >
            {data.map(({ label, value }) => (
              <Tab className="probaTaba px-2 py-1" key={value} value={value}>
                {label}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody>
            {data.map(({ value, tabs, desc, image, desc2 }) => (
              <TabPanel key={value} value={value}>
                {value === "podaci" ? (
                  <Tabs
                    value={activePodaciTab}
                    onChange={(val) => setActivePodaciTab(val)}
                  >
                    <TabsHeader className="bg-gray-200">
                      {tabs.map(({ label, value }) => (
                        <Tab key={value} value={value}>
                          {label}
                        </Tab>
                      ))}
                    </TabsHeader>
                    <TabsBody>
                      {tabs.map(({ value, content }) => (
                        <TabPanel key={value} value={value}>
                          {content}
                        </TabPanel>
                      ))}
                    </TabsBody>
                  </Tabs>
                ) : (
                  <>
                    {/* Prikaz za ostale glavne tabove kao što su Uvod, Metodologija itd. */}
                    <div className="suseDeo flex flex-col md:flex-row">
                      <div className="suseDeoVeci w-full md:w-3/5 p-4">
                        {image && ReactHtmlParser(image)}
                        {desc2 && ReactHtmlParser(desc2)}
                      </div>
                      <div className="suseDeoManji w-full md:w-2/5 p-4 bg-white mt-6 md:mt-0">
                        {desc && ReactHtmlParser(desc)}
                      </div>
                    </div>
                  </>
                )}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </div>
      <Form />
      <Footer />
    </>
  );
}
